export type LegacyArticle = {
  path: string;
  title: string;
  description: string;
  heading: string;
  paragraphs: string[];
  items?: string[];
  sections?: Array<{ title: string; items: string[] }>;
};

export const LEGACY_ARTICLES: LegacyArticle[] = [
  {
    path: '/como-o-erp-da-lukos-tecnologia-pode-transformar-a-gestao-do-seu-posto',
    title: 'Lukos | Como o ERP pode transformar a gestão do seu posto',
    description: 'Com o ERP da Lukos, seu posto ganha eficiência, controle e competitividade.',
    heading: 'Como o ERP da Lukos Tecnologia pode transformar a gestão do seu posto?',
    paragraphs: [
      'Com o ERP da Lukos, seu posto ganha eficiência, controle e competitividade. Consulte-nos.',
    ],
    items: [
      'Controle Financeiro Completo: gerencie entradas, saídas, contas a pagar e a receber de forma integrada, garantindo clareza nas finanças.',
      'Gestão de Estoque Eficiente: acompanhe o estoque de combustíveis, lubrificantes e outros produtos em tempo real, evitando rupturas ou excessos.',
      'Automação de Processos: centralize operações como vendas, pagamentos e conciliação de cartões, reduzindo erros manuais e otimizando o tempo.',
      'Relatórios e Análises: obtenha insights detalhados sobre o desempenho do posto para tomar decisões estratégicas com base em dados confiáveis diretamente pelo celular.',
      'Conformidade e Fiscalização: facilite o envio de obrigações fiscais e mantenha-se em conformidade com as regulamentações do setor.',
      'IA aplicada ao seu posto: tenha acesso à inteligência artificial, contribuindo com as atividades operacionais, relatórios, consultas e auxílio na gestão de postos.',
    ],
  },
  {
    path: '/programa-de-fidelidade-lukos',
    title: 'Lukos | Programa de Fidelidade para postos de gasolina',
    description: 'Simples, prático e 100% gerenciado pelo WhatsApp. Programa de fidelidade Lukos para postos de gasolina.',
    heading: 'Programa de Fidelidade Lukos para Postos de Gasolina',
    paragraphs: [
      'Simples, prático e 100% gerenciado pelo WhatsApp.',
      'Na Lukos Tecnologia, entendemos a importância de oferecer soluções modernas e acessíveis para fidelizar seus clientes. Por isso, desenvolvemos um Programa de Fidelidade exclusivo para postos de gasolina, totalmente integrado ao WhatsApp, tornando a gestão rápida e prática tanto para o posto quanto para o cliente.',
      'Invista no futuro da fidelização com a Lukos Tecnologia. Transforme a relação com seus clientes em algo mais próximo e vantajoso para todos, utilizando uma plataforma que eles já conhecem e confiam.',
    ],
    sections: [
      {
        title: 'Como funciona?',
        items: [
          'Cadastro simples: seus clientes podem se cadastrar no programa diretamente pelo WhatsApp, sem complicações.',
          'Acúmulo de pontos: a cada abastecimento ou serviço utilizado, o cliente acumula pontos automaticamente.',
          'Resgate de benefícios: com poucos cliques, o cliente consulta o saldo de pontos e resgata benefícios, como descontos em combustíveis, lavagens gratuitas e muito mais.',
        ],
      },
      {
        title: 'Vantagens para o posto',
        items: [
          'Fidelização aumentada: mantenha seus clientes voltando ao seu posto regularmente.',
          'Gestão simplificada: administre o programa diretamente pelo WhatsApp, sem necessidade de sistemas complexos.',
          'Comunicação direta: envie promoções personalizadas e informações importantes diretamente para os clientes.',
          'Relatórios inteligentes: acompanhe o desempenho do programa em tempo real.',
        ],
      },
      {
        title: 'Benefícios para o cliente',
        items: [
          'Cadastro fácil e rápido, sem precisar baixar aplicativos extras.',
          'Resgate de vantagens de maneira prática pelo WhatsApp.',
          'Experiência moderna e intuitiva.',
        ],
      },
    ],
  },
  {
    path: '/i-a-aplicada-ao-dia-a-dia-do-posto',
    title: 'Lukos | IA aplicada ao dia a dia do posto',
    description: 'A tecnologia está mudando a forma como os postos de combustíveis operam. A inteligência artificial ajuda na gestão e na operação.',
    heading: 'Como a Inteligência Artificial Está Revolucionando a Gestão de Postos de Combustíveis',
    paragraphs: [
      'A tecnologia está mudando a forma como diversos setores operam, e os postos de combustíveis não ficam de fora dessa transformação. A Inteligência Artificial (IA) tem se destacado como uma poderosa aliada na gestão e operação desses estabelecimentos, trazendo inovação, eficiência e resultados superiores.',
      'Todas as informações de vendas, resultados e conciliações podem ser facilmente verificadas através do WhatsApp: você solicita como deseja receber a informação e a IA envia da maneira desejada.',
      'A implementação da Inteligência Artificial nos postos de combustíveis não só melhora a eficiência operacional como também eleva a experiência do cliente. Com serviços personalizados e atendimento mais ágil, os postos que adotam IA ganham destaque no mercado e aumentam a fidelização.',
      'Veja como o software da Lukos pode entregar a IA aplicada ao gestor de posto de combustível. Consulte-nos.',
    ],
    sections: [
      {
        title: 'O que a IA faz pelos postos de combustíveis?',
        items: [
          'Otimização de estoques: prever a demanda de combustíveis e outros produtos com alta precisão, analisando dados históricos, padrões e comportamentos dos clientes, para evitar desperdícios e manter o estoque adequado.',
          'Gestão de preços inteligente: monitorar as flutuações do mercado e sugerir modificações de preços, buscando competitividade e margens otimizadas.',
          'Análise de comportamento do cliente: entender hábitos de consumo para promoções e estratégias de fidelização. A identificação do cliente ajuda no entendimento da carteira e na gestão de escala diária.',
          'Monitoramento e manutenção preventiva: identificar problemas em equipamentos, como bombas e filtragem, antes de falhas ou interrupções.',
          'Automação de processos: do gerenciamento de caixas à emissão de relatórios financeiros, simplificando tarefas repetitivas.',
          'Segurança e prevenção de fraudes: ajudar a identificar comportamentos suspeitos e reduzir perdas.',
        ],
      },
    ],
  },
  {
    path: '/ola-mundo',
    title: 'Lukos | 5 tópicos sobre conciliação de cartões',
    description: 'A conciliação de pagamentos é um grande desafio para o lojista. Confira 5 tópicos importantes sobre a conciliação de cartões.',
    heading: '5 Tópicos importantes sobre a Conciliação de Cartões – Lukos',
    paragraphs: [
      'A conciliação de pagamentos é sempre um grande desafio para o lojista. É quase impossível realizar a conferência das taxas cobradas pelo cartão e os valores que são liquidados no banco, mas esta dificuldade não existe para quem possui aplicação da Lukos.',
    ],
    items: [
      'Controle financeiro: verifique se os valores pagos pelas operadoras de cartão estão alinhados com as vendas realizadas, garantindo precisão nos registros financeiros.',
      'Redução de erros: identifique e corrija divergências em taxas, antecipações e valores não recebidos, minimizando prejuízos.',
      'Automatização de processos: utilize sistemas que conciliam automaticamente as informações das vendas com os extratos das operadoras, economizando tempo e esforço.',
      'Gestão de taxas: acompanhe as tarifas cobradas pelas operadoras para negociar melhores condições e otimizar a lucratividade.',
      'Tomada de decisão: obtenha dados claros e organizados para melhorar o planejamento financeiro e fortalecer a gestão do fluxo de caixa.',
    ],
  },
];

export function legacyArticleByPath(pathname: string): LegacyArticle | undefined {
  const path = pathname.replace(/\/+$/, '') || '/';
  return LEGACY_ARTICLES.find((article) => article.path === path);
}
